interface ShopPhoneIconProps {
    color?: string;
    width?: number | string;
    height?: number | string;
    className?: string;
    svgProps?: React.SVGProps<SVGSVGElement>;
}

const ShopPhoneIcon = ({ color = 'currentColor', width = 36, height = 36, className, svgProps }: ShopPhoneIconProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 36 36" fill="none" className={className} {...svgProps}>
            <path
                d="M10.8486 7.5752C11.8732 7.31911 12.9484 7.73456 13.5342 8.61328L14.9189 10.6904C15.2561 11.1962 15.3865 11.8121 15.2832 12.4111C15.1439 13.2187 14.5978 13.8978 13.8389 14.207L12.6211 14.7031L11.7129 15.0732L12.0645 15.9883L12.2979 16.5938C13.6434 20.0921 16.4079 22.8566 19.9062 24.2021L20.5117 24.4355L21.4268 24.7871L21.7969 23.8789L22.293 22.6611C22.6022 21.9022 23.2813 21.3561 24.0889 21.2168C24.6879 21.1135 25.3038 21.2439 25.8096 21.5811L27.8867 22.9658C28.7654 23.5516 29.1809 24.6268 28.9248 25.6514L28.4092 27.7168C28.1472 28.7648 27.2052 29.5 26.125 29.5C15.5626 29.5 7 20.9374 7 10.375C7.00001 9.29475 7.73521 8.35282 8.7832 8.09082L10.8486 7.5752Z"
                stroke={color}
                strokeWidth="2"
            />
        </svg>
    );
};

export default ShopPhoneIcon;
